function About() {
  return (
    <div>
      <h1 className="text-6xl">Github Finder</h1>
      <p className="mb-4 text-2xl font-light">
        React App to search Github profiles and see profile details. This project is part of the Udemy Course by Brad Traversy.
      </p>
      <p className="text-lg text-gray-400">
        Version <span className="text-white">1.0.0</span>
      </p>
    </div>
  )
}

export default About